import React from 'react';
import PropTypes from 'prop-types';

import {Icon} from 'semantic-ui-react';

const AddressDirections = ({destination,startingPoint}) => {
    startingPoint = startingPoint ? startingPoint : '';
    return (
        <div className="address">
            <a target="blank" href={`https://www.google.com/maps/dir/${startingPoint}/${destination.join(' ')}`}>
            {destination.map((line,key)=>(
                <span key={key}>
                    {line}                    
                    </span>
                ))
            }                     
            </a>
            <Icon name="external"/>            
        </div>
    );
};

AddressDirections.propTypes = {
    startingPoint: PropTypes.string,
    destination: PropTypes.array.isRequired,
};

export default AddressDirections;